module.exports = __webpack_public_path__ + "static/media/icon-faqs-full.376da42a.png";